import React, { useState} from 'react';

const Quiz = ({question, onAnswerSelect, showResult}) =>{
    const [selectAnswer, setSelectedAnswer] = useState(null);
    const OptionClick = (option) =>{
        setSelectedAnswer(option);
        onAnswerSelect(option);
    };
    const setClass = (option) =>{
        let className = "option-button";
        if(selectAnswer === option){
            className += " selected";
        }
        if(showResult){
            if(option === question.correctAnswer){
                className += " correctAnswer";
            }else if(selectAnswer===option && selectAnswer !== question.correctAnswer){
                className += " badAnswer";
            }
        }
        return className;
    };
    return (
        <div>
            <h2>{question.question}</h2>
            <div className="options">
                {question.options.map((option, index)=>(
                    <button key={index} className={setClass(option)} onClick={() => OptionClick(option)} disabled={showResult}> {option} </button>
                ))}
            </div>
        </div>
    );
};

export default Quiz;